import styled from 'styled-components';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';
import zIndex from 'theme/zIndex';

export const DropdownContainer = styled.div`
    position: relative;
`;
export const Label = styled.div`
    display: block;
    margin-bottom: 8px;
`;
export const InputContainer = styled.div`
    padding: 7px 12px;
    border: 1px solid ${(props) => (props.isDisabled ? promoColors.gray5 : promoColors.gray20)};
    background: ${(props) => (props.isDisabled ? promoColors.gray5 : promoColors.white)};
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: ${(props) => (props.isDisabled ? null : 'pointer')};
    pointer-events: ${(props) => (props.isDisabled ? 'none' : null)};
`;
export const Placeholder = styled.div`
    flex: 1;
`;
export const DropdownList = styled.div`
    position: absolute;
    top: ${(props) => (props.hasLabel ? '24px' : '0')};
    left: 0;
    background: ${promoColors.white};
    box-shadow: ${promoColors.shadowCollected};
    border-radius: 8px;
    padding: 4px 0;
    width: 100%;
    z-index: ${zIndex.landingDropdown};
    max-height: 232px;
    overflow: auto;

    ${promoMedia.desktop1440} {
        max-height: 240px;
    }
`;
export const DropdownItem = styled.div`
    display: block;
    padding: 10px 16px;
    cursor: pointer;
    color: ${(props) => (props.isSelected ? promoColors.primary : 'inherit')};

    h2 {
        font-size: inherit;
        font-weight: inherit;
    }

    &:link,
    &:visited {
        color: ${(props) => (props.isSelected ? promoColors.primary : 'inherit')};
    }

    &:hover {
        background: ${promoColors.purple5};
    }

    ${promoMedia.desktop1440} {
        padding: 12px 16px;
    }
`;
